/**
 * checkBetriebsleiterMitarbeiterClick
 * @param element
 */
window.checkBetriebsleiterMitarbeiterClick = function (element) {
    $(element).on('click', function (e) {
        if (!$(e.target).closest('div').hasClass('no-click')) {
            const row = $(e.target).closest(element);
            openBetriebsleiterMitarbeiter(Number(row.data('id')));
        }
    });
};

/**
 * openBetriebsleiterMitarbeiter
 * @param id
 */
window.openBetriebsleiterMitarbeiter = function (id) {
    window.location = BASE_PATH + 'betriebsdaten/betriebsleiterMitarbeiterEdit/' + id;
};

/**
 * checkUserVermarktungsbetrieb
 * @param element
 */
window.checkUserVermarktungsbetrieb = function (element) {
    const vermarktungElements = $('#vermarktung-betrieb, #vermarktung-nummer');
    vermarktungElements.attr('disabled', 'disabled');
    if (Number($(element).val()) === 1) {
        vermarktungElements.removeAttr('disabled');
    }
};